"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//

exports.default = {
  props: ["message", "isError"],

  computed: {
    classes: function classes() {
      var classes = ["text-center", "mt-min"];

      classes.push(this.isError ? "error" : "info");

      return classes;
    },
    messageToShow: function messageToShow() {
      if (this.message) {
        return this.message;
      }

      if (this.isError) {
        return this.$t("common.messages.unknown_error");
      }
    }
  }
};


//////////////////
// WEBPACK FOOTER
// ./~/babel-loader/lib?cacheDirectory!./~/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/elements/MessageBlock.vue
// module id = zk6B
// module chunks = 1